import { Card, Typography, Row, Switch, message, Spin } from "antd";
import { useState, useEffect } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

const News = () => {
    const [loading, setLoading] = useState(false);
    const [marketingSwitch, setMarketingSwitch] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        HTTPClient.get("/notifications/marketing")
            .then((response) => {
                setMarketingSwitch(response.data.marketing_notifications);
            })
            .catch((error) => {
                message.error(t("home.news.fetch_error"));
            });
    }, []);

    const onChange = (checked) => {
        setLoading(true);
        HTTPClient.post("/notifications/marketing", { marketing_notifications: checked })
            .then((response) => {
                message.success(t("home.news.success"));
                setMarketingSwitch(response.data.marketing_notifications);
            })
            .catch((error) => {
                message.error(t("home.news.error"));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    if (loading) return <Spin size="large" />;

    return (
        <Card
            bordered={true}
            style={{
                width: "100%",
                borderRadius: "10px",
                marginTop: "20px",
            }}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "250px",
                    justifyContent: "space-between",
                }}>
                <div></div>
                <div>
                    <Row>
                        <Typography.Text
                            style={{ fontSize: "medium", fontWeight: "bold", textAlign: "center" }}>
                            {t("home.news.info")}
                        </Typography.Text>
                    </Row>
                </div>

                <Row
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                    }}>
                    <Switch
                        loading={loading}
                        onChange={onChange}
                        checkedChildren={t("home.news.active")}
                        unCheckedChildren={t("home.news.disabled")}
                        checked={marketingSwitch}
                        size="large"
                    />
                </Row>
            </div>
        </Card>
    );
};
export { News };
